import React from "react";
import { useSelector } from "react-redux";
import { icon, label, number } from "../../../../config";
import { commentDateAndTimeFormat } from "../../../../helper/common";
import CommentsDropdown from "./CommentDropdown";
import CommentImages from "./CommentImages";
import EmojiReactionMenu from "./EmojiReactionMenu";
import EmojiReactions from "./EmojiReactions";
import { commentImagesTypes } from "./commentsHelper";

const CommentReply = ({
  replyItem,
  commentId,
  taskId,
  moveFocusToEditor,
  moveTaskSidebarScrollToEditor,
  setReplyBubble,
  handlingCommentAndReplyText,
  handleReplyEmojiReaction,
  showReplyActions = true,
}) => {
  const { Id, ReplyText, isEdited, CreatedOn, LastUpdatedOn, Name, UserId, PhotoLinks, ReplyImages } = replyItem;
  const userId = useSelector((state) => state.auth.user.id);
  const { isNewTask } = useSelector((state) => state.taskSidebar);
  const { allReplies } = useSelector((state) => state.comments);

  /** Get the reply with emoji reactions from the Redux store
   * @author Muskan Thakur
   */
  const replyWithEmojis = allReplies[commentId]?.find((reply) => reply.Id === Id) || replyItem;

  return (
    <div id='reply-section-id' className='reply-section mb-3 pb-2 w-100 border-bottom'>
      <div id='reply-header' className='comment-header d-flex justify-content-between align-items-center'>
        <div id='reply-details' className='d-flex align-items-center'>
          {PhotoLinks?.small ? (
            <div className='comment-user-image-container'>
              <img alt={label.PROFILE_PICTURE} className='comment-user-image object-fit-cover border-radius-50' src={PhotoLinks?.small}></img>
            </div>
          ) : (
            <span className={`d-flex  ${UserId === userId ? "active-user" : ""}`}>{icon.USER_ICON}</span>
          )}
          <span className={`ml-1 mr-2 mb-0 font-weight-bold text-truncate ${UserId === userId ? "active-user" : ""}`}>{Name}</span>
          <span className='comment-time d-flex align-items-center text-nowrap info-text'>- {LastUpdatedOn ? commentDateAndTimeFormat(LastUpdatedOn) : commentDateAndTimeFormat(CreatedOn)}</span>
          <span className='ml-2'>{isEdited === number.ONE && label.EDITED}</span>
        </div>
        {showReplyActions && (
          <div id='reply-header-action' className='d-flex justify-content-between align-items-center flex-wrap mb-2'>
            <EmojiReactionMenu type='reply' replyId={Id} commentId={commentId} handleReplyEmojiReaction={handleReplyEmojiReaction} />
            {UserId === userId && (
              <span>
                <CommentsDropdown
                  reply={replyItem}
                  commentId={commentId}
                  taskId={taskId}
                  replyId={Id}
                  type={"reply"}
                  moveFocusToEditor={moveFocusToEditor}
                  moveTaskSidebarScrollToEditor={moveTaskSidebarScrollToEditor}
                  setReplyBubble={setReplyBubble}
                  isNewTask={isNewTask}
                  isOwnComment={replyItem.UserId === userId}
                />
              </span>
            )}
          </div>
        )}
      </div>

      <div id='reply-text-id' className='comment-reply-text reply-text'>
        {ReplyText && handlingCommentAndReplyText(ReplyText)}
      </div>

      {ReplyImages && <CommentImages commentImagesType={commentImagesTypes.REPLY_IMAGES} entityImages={ReplyImages} reply={replyItem} commentId={commentId} />}

      <EmojiReactions type='reply' entity={replyWithEmojis} commentId={commentId} taskId={taskId} />
    </div>
  );
};

export default CommentReply;
